// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1e368051","455":"72a689e6","977":"ccf946b7"}[chunkId] + ".chunk.js";
};